<template>
    <div>
        <lottie-player 
            src="https://assets8.lottiefiles.com/packages/lf20_bw7e3wn6.json" :options="{
                autoplay: true,
            }">
        </lottie-player>
    </div>
</template>
<script>
export default {
    name:"AnimatedLogo",
    data() {
        return {
        
        }
    }

}
</script>